import { useIsDarkMode } from "store/atoms";
import { JsonEditor } from "jsoneditor-react";
import brace from "brace";
import "brace/mode/json";
import "brace/theme/github";
import "brace/ext/searchbox";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import { filterObjectByRemovingKeys } from "utils/arrayUtils";

export const CustomJsonEditor = ({
  height,
  ...props
}: {
  height?: number;
  value: string | Record<string, unknown> | any[];
} & Record<string, unknown>) => {
  const [isDarkMode] = useIsDarkMode();

  return (
    <ErrorBoundary small={true} id="CustomJsonEditor">
      <JsonEditor
        htmlElementProps={{
          style: { height: height ?? 600, width: props.width },
        }}
        mode="code"
        allowedModes={["code", "text", "tree", "form"]}
        search={true}
        ace={brace}
        theme={isDarkMode ? "monokai" : "ace/theme/github"}
        {...filterObjectByRemovingKeys(props, ["width"])}
        value={props.value ?? ""}
      />
    </ErrorBoundary>
  );
};
